import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { HubProvider } from "./context/HubContext";
import ProtectedRoute from "./components/layout/ProtectedRoute";
import DashboardLayout from "./components/layout/DashboardLayout";
import Login from "./pages/Login";
import Overview from "./pages/ingroove/Overview";
import Events from "./pages/ingroove/Events";
import EventDetail from "./pages/ingroove/EventDetail";
import Attendees from "./pages/ingroove/Attendees";
import HubPartners from "./pages/ingroove/HubPartners";
import Reports from "./pages/ingroove/Reports";
import Wallet from "./pages/ingroove/Wallet";
import HubDetail from "./pages/ingroove/HubDetail";

function App() {
  return (
    <AuthProvider>
      <HubProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<DashboardLayout />}>
                <Route path="/" element={<Navigate to="/overview" replace />} />
                <Route path="/overview" element={<Overview />} />
                <Route path="/events" element={<Events />} />
                <Route path="/events/:eventId" element={<EventDetail />} />
                <Route path="/attendees" element={<Attendees />} />
                <Route path="/hub-partners" element={<HubPartners />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/wallet" element={<Wallet />} />
                <Route path="/hub-details" element={<HubDetail />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </HubProvider>
    </AuthProvider>
  );
}

export default App;

// npm run build
// firebase deploy
